import * as React from 'react';
import { runOnJS, useAnimatedReaction } from 'react-native-reanimated';
import { AnimatedText } from 'design-system/AnimatedComponents';
import BlurAmountView from 'design-system/BlurAmountView';
import { useAppSelector } from 'store/hooks';
const HeaderText = ({ texts, selectedIndex, fallback, style, scramblable, blurStyle, }) => {
    const [text, setText] = React.useState(fallback);
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    useAnimatedReaction(() => texts[selectedIndex.value] ?? fallback, (current, previous) => {
        if (current !== previous) {
            runOnJS(setText)(current);
        }
    }, [texts, fallback]);
    const content = (<AnimatedText numberOfLines={1} allowFontScaling={false} style={style}>
      {text}
    </AnimatedText>);
    return scramblable ? (<BlurAmountView enabled={scrambled} blurStyle={blurStyle}>
      {content}
    </BlurAmountView>) : (content);
};
export default HeaderText;
